"use strict";
/**
 * Created by rouven on 12.04.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var uuid_1 = __importDefault(require("uuid"));
var withTooltip = function (Tooltip) { return function (Component) {
    if (!Tooltip)
        return Component;
    var id = 'symbol_' + (0, uuid_1["default"])();
    var params = {
        'data-tip': true,
        'data-for': id
    };
    var TooltipComponent = (react_1["default"].createElement(react_tooltip_1["default"], { id: id }, typeof Tooltip === 'function' ? react_1["default"].createElement(Tooltip, null) : Tooltip));
    return (react_1["default"].createElement("span", null,
        react_1["default"].createElement("span", __assign({}, params), Component),
        react_dom_1["default"].createPortal(TooltipComponent, document.getElementsByTagName('body')[0])));
}; };
exports["default"] = withTooltip;
